import { render } from "./Members.vue?vue&type=template&id=23367a6d"
import script from "./Members.vue?vue&type=script&lang=js"
export * from "./Members.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__